import { render, staticRenderFns } from "./countryGuide.vue?vue&type=template&id=8bdd6f74&scoped=true"
import script from "./countryGuide.vue?vue&type=script&lang=js"
export * from "./countryGuide.vue?vue&type=script&lang=js"
import style0 from "./countryGuide.vue?vue&type=style&index=0&id=8bdd6f74&prod&lang=scss&scoped=true"
import style1 from "./countryGuide.vue?vue&type=style&index=1&id=8bdd6f74&prod&scoped=true&lang=css"
import style2 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./countryGuide.vue?vue&type=style&index=3&id=8bdd6f74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdd6f74",
  null
  
)

export default component.exports